export enum ShowContactActionKind {
  SET_CONTACT_STATUS = "SET_CONTACT_STATUS",
}

export interface ShowContactState {
  showContact: boolean;
}

export interface ShowContactAction {
  type: ShowContactActionKind;
  payload: ShowContactState;
}
